import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import ServiceService from '@clickersphere/core/services/ServiceService';
import useToast from '../useToast';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { SERVICE_PACKAGES_QUERY_KEY } from '../service-package/useServicePackages';
import { SERVICES_QUERY_KEY } from './useServices';

export function useDetachServiceFromPackages() {
  const queryClient = useQueryClient();
  const { buildQueryKey } = useBuildQueryKey();
  const { toast } = useToast();
  const { t } = useTranslation();

  const { isPending: detachServiceIsPending, mutateAsync: detachServiceAsync } =
    useMutation({
      mutationFn: (id: string) => ServiceService.detachFromAllPackages(id),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: buildQueryKey(SERVICES_QUERY_KEY),
        });
        queryClient.invalidateQueries({
          queryKey: buildQueryKey(SERVICE_PACKAGES_QUERY_KEY),
        });
        toast(t('catalog.toasts.serviceDetached'), 'success');
      },
      onError: () => {
        toast(t('catalog.toasts.serviceDetachError'), 'error');
      },
    });

  return {
    detachServiceAsync,
    detachServiceIsPending,
  };
}
